"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = require("../../Theme/Theme.variables");

var _styledSystem = require("styled-system");

var _Box = require("../../components/Box/Box");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          color: ", ";\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  text-align: left;\n\n  label {\n    font-family: ", ";\n    font-size: ", "px;\n    letter-spacing: ", ";\n    line-height: ", ";\n\n    /* color */\n    ", ";\n    letter-spacing: 0;\n    display: block;\n    padding-left: 20px;\n    cursor: pointer;\n    position: relative;\n    z-index: 100;\n    transition: color 0.1s ease;\n    text-transform: none;\n  }\n\n  input[type='radio'] {\n    appearance: none;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 100;\n    cursor: pointer;\n    margin: 0;\n    padding: 0;\n    &:before {\n      content: '';\n      width: 12px;\n      height: 12px;\n      display: block;\n      border-radius: 100%;\n      cursor: pointer;\n      background: ", ";\n      position: absolute;\n      top: 50%;\n      left: 0;\n      transform: translateY(-50%);\n      border: 1px solid ", ";\n      box-shadow: inset 0 0 0 3px ", ";\n    }\n    &:checked:before {\n      background: ", ";\n    }\n    &:checked ~ label {\n      ", ";\n    }\n  }\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledRadio = (0, _styledComponents.default)(_Box.Box)(_templateObject(), function (props) {
  return (0, _Theme.variables)(props).fontBody;
}, function (props) {
  return props.small ? (0, _Theme.variables)(props).fontSizeSm : (0, _Theme.variables)(props).fontSizeBase;
}, function (props) {
  return props.small ? (0, _Theme.variables)(props).letterSpacing.body[2] : (0, _Theme.variables)(props).letterSpacing.body[1];
}, function (props) {
  return (0, _Theme.variables)(props).fontBaseLineHeight;
}, function (props) {
  return props.textColor && (0, _styledComponents.css)(_templateObject2(), (0, _Theme.variables)(props)[props.textColor]);
}, function (props) {
  return (0, _Theme.variables)(props).white;
}, function (props) {
  return (0, _Theme.variables)(props).black;
}, function (props) {
  return (0, _Theme.variables)(props).white;
}, function (props) {
  return (0, _Theme.variables)(props)['primary'];
}, function (props) {
  return (0, _styledComponents.css)(_templateObject3(), (0, _Theme.variables)(props)['textPrimary']);
}, _styledSystem.space);

var Radio = function Radio(_ref) {
  var props = _extends({}, _ref);

  return _react.default.createElement(StyledRadio, _extends({}, props, {
    id: undefined,
    type: undefined,
    label: undefined,
    name: undefined,
    value: undefined,
    checked: undefined,
    onChange: null,
    onClick: null,
    textColor: props.textColor
  }), _react.default.createElement("input", {
    id: props.id,
    type: "radio",
    name: props.name,
    value: props.value,
    checked: props.checked ? true : false,
    onChange: props.onChange,
    onClick: props.onClick
  }), props.label && _react.default.createElement("label", {
    htmlFor: props.id
  }, props.label));
};

exports.Radio = Radio;
Radio.displayName = 'Radio'; // Prop Types

Radio.propTypes = {};
Radio.defaultProps = {};